import { render, staticRenderFns } from "./hsbcJudgeHistory.vue?vue&type=template&id=01f3a0ff&scoped=true"
import script from "./hsbcJudgeHistory.vue?vue&type=script&lang=js"
export * from "./hsbcJudgeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3a0ff",
  null
  
)

export default component.exports